module.exports = __webpack_public_path__ + "img/c-en-31.16844779.png";